var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNtbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 24 0 24 32 0 32"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ntb-layout-nyheter-image",
    transform: "translate(-165.000000, -5017.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(-114.000000, 5017.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(279.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1432329,15.5970379 C72.1083784,14.9224535 74.5618425,12.8998184 74.5618425,9.25862792 C74.5618425,3.72893671 71.0980002,0 64.6150128,0 L52,0 L52,32 L65.2722491,32 C70.8364136,32 75,28.6717899 75,22.5625262 C75,18.0684644 72.4157426,16.4040799 71.1432329,15.5970379 L71.1432329,15.5970379 Z M59.0197849,6.66703926 L64.3659606,6.66703926 C66.7218747,6.66703926 67.455952,8.17493363 67.455952,9.58502166 C67.455952,10.9939919 66.7218747,12.5024452 64.3659606,12.5024452 L59.0197849,12.5024452 L59.0197849,6.66703926 Z M64.7643351,25.3206651 L59.0410388,25.3206651 L59.0410388,19.1046528 L64.7643351,19.1046528 C67.0924557,19.1046528 67.8684959,20.6963812 67.8684959,22.1869498 C67.8684959,23.6791952 67.0924557,25.3206651 64.7643351,25.3206651 L64.7643351,25.3206651 Z",
    id: "Fill-1",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FF9900",
    mask: "url(#mask-2)",
    points: "16.5653671 16.4130222 6.14519906 0 0 0 0 32 7.43793911 32 7.43793911 15.5864189 17.8608624 32 24 32 24 0 16.5653671 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FF9900",
    points: "26 6.48238176 33.9748308 6.48238176 37.5040691 3.21269511 37.5040691 9.12461859 33.9905645 12.5240289 33.9905645 37 37.5279409 33.7346556 37.5279409 31.0734215 41.0034676 31.0734215 41.0034676 6.48238176 49 6.48238176 49 0 26 0"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtbLogo);
export default __webpack_public_path__ + "static/media/ntb-logo.9b260fe795b81ce7139442a6eaf519f5.svg";
export { ForwardRef as ReactComponent };